module.exports = __webpack_public_path__ + "img/输入邀请码.40ac765a.svg";